import React from "react";
import styles from "./SortIcon.module.scss";

import { SortIcon as Icon } from "../../assets/customIcons";

export interface ISortIconProps {
  direction?: string;
}

export const SortIcon: React.FC<ISortIconProps> = ({
  direction = "",
}) => {
  const className = styles[`sort-icon--${direction}`];
  return (
    <Icon width="15px" className={`${styles['sort-icon']} ${className}`} />
  );
};
